import protoRoot from "../proto-root";
import ParentStationState from "../private/ParentStationState";

const name = "syncFromPSRPCRequest";

function create({ parentStationState }) {
  const SyncFromPSRPCRequest = protoRoot.lookupType(
    "comm.SyncFromPSRPCRequest"
  );

  const request = SyncFromPSRPCRequest.create({
    parentStationState: ParentStationState.create(parentStationState)
  });

  return { payload: request, name, sendBy: "xmpp" };
}

export default {
  create,
  name
};
